import { Box, Container } from '@mui/material';
import { MARKETPLACE_SERVICES } from '../constants/marketplaceServices';
import { sections } from '../data/homepage';
import MarketplaceCTA from './marketplace/MarketplaceCTA';
import MarketplaceHeader from './marketplace/MarketplaceHeader';
import ServiceCard from './molecules/ServiceCard';

// Configuration: Adjust these values to customize the grid layout
const GRID_COLUMNS = 3;
const CONTAINER_MAX_WIDTH = '1200px';

/**
 * MarketplaceSection2 - Full width marketplace layout
 * Uses atomic components and follows established design patterns
 *
 * @returns {React.ReactElement} Marketplace section with full width layout
 */
function MarketplaceSection2() {
  return (
    <Box
      sx={{
        width: '100vw',
        backgroundColor: 'var(--color-background-light)',
        position: 'relative',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
      }}
    >
      {/* Header with green bars - now using reusable component */}
      <MarketplaceHeader title={sections.services.heading} />

      {/* Main content area with wider container for cards+CTA layout */}
      <Container
        maxWidth={false}
        sx={{
          pb: 8,
          px: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 },
          maxWidth: CONTAINER_MAX_WIDTH,
          mx: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 4,
            flexWrap: { xs: 'wrap', xl: 'nowrap' },
            width: '100%',
          }}
        >
          {/* Cards Grid - Left Side */}
          <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(2, 1fr)',
                  md: 'repeat(2, 1fr)',
                  lg: `repeat(${GRID_COLUMNS}, 1fr)`,
                  xl: `repeat(${GRID_COLUMNS}, 1fr)`,
                },
                gap: 3,
                width: '100%',
              }}
            >
              {MARKETPLACE_SERVICES.map((service, index) => (
                <ServiceCard
                  key={service.title}
                  category={service.category}
                  title={service.title}
                  description={service.description}
                  buttonText={service.buttonText}
                  link={service.link}
                  index={index}
                  fullWidth={true}
                  badgeUrl={service.badgeUrl}
                  badgeAlt={service.badgeAlt}
                  comingSoon={service.comingSoon}
                  actionButton={service.actionButton}
                />
              ))}
            </Box>
          </Box>

          {/* LinkedIn CTA - Right Side - now using reusable component */}
          <Box
            sx={{
              flex: '0 0 auto',
              width: { xs: '100%', xl: '320px' },
              position: { xs: 'static', xl: 'sticky' },
              top: { xl: 100 },
              height: 'fit-content',
            }}
          >
            <MarketplaceCTA />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default MarketplaceSection2;
